import SampleReportView from "@/components/samples/SampleReportView";
import { ENERFLO_REPORT } from "@/data/sample-reports";

const EnerfloSample = () => <SampleReportView report={ENERFLO_REPORT} />;

export default EnerfloSample;
